import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@mui/material";
import { Check, Close } from "@mui/icons-material";

import messages from "../../../assets/locale/messages";
import Button from "../../../components/Button";
import EmptyState from "../../../components/EmptyState";
import noCategoryImg from "../../../assets/images/placeholders/noCategoryImagePlaceholder.svg";
import noRequestImg from "../../../assets/images/placeholders/noProductImagePlacholder.svg";
import {
  getCategoryRequestDetailsRequest,
  getCategoryRequestDetailsResponse
} from "../../../store/Categories/actions";
import { CATEGORY_STATUS_IDS } from "../../../utils/Constants";
import { hasPermission, PERMISSIONS_IDS } from "../../../utils/Roles";
import AcceptCategoryRequest from "../AcceptCategoryRequestModal";
import RejectCategoryRequest from "../RejectCategoryReqeustModal";
import "./CategoryRequestDetails.scss";

const CategoryRequestDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const isLoading = useSelector((state) => state.loader.showLoader);
  const lang = useSelector((state) => state.locale.lang);
  const categoryDetails = useSelector(
    (state) => state.categories.categoryRequestDetails
  );

  const [
    isAcceptCategoryRequestModalOpen,
    setIsAcceptCategoryRequestModalOpen
  ] = useState(false);

  const [
    isRejectCategoryRequestModalOpen,
    setIsRejectCategoryRequestModalOpen
  ] = useState(false);

  const [categoryInfo, setCategoryInfo] = useState({});

  const {
    categories: {
      categoriesRequests: { requestDetails }
    },
    shared
  } = messages[lang];

  useEffect(() => {
    if (id) {
      dispatch(getCategoryRequestDetailsRequest({ id }));
    }
    return () => {
      dispatch(getCategoryRequestDetailsResponse({}));
    };
  }, [id]);

  const onImageError = (e) => {
    e.target.src = noRequestImg;
  };

  const handleCloseModal = () => {
    setIsAcceptCategoryRequestModalOpen(false);
    setIsRejectCategoryRequestModalOpen(false);
    setCategoryInfo({});
  };

  return (
    <div className="category-request-details-container">
      {!isLoading && (
        <>
          {categoryDetails &&
          !!Object.keys(categoryDetails).length ? (
            <>
              <div className="page-title-buttons-container pb-4 d-flex justify-content-between align-items-sm-center align-items-start flex-column flex-sm-row">
                <div className="page-title mb-3 mb-md-0">
                  <Typography variant="h5">
                    {requestDetails.categoryRequestDetails}
                  </Typography>
                </div>
                {hasPermission(
                  PERMISSIONS_IDS.category_request_accept_reject
                ) && (
                  <>
                    {categoryDetails?.CategoryStatusId ===
                      CATEGORY_STATUS_IDS.pending && (
                      <div className="d-flex gap-3">
                        <Button
                          label={
                            <>
                              <Close className="me-1" />
                              <span>{shared.reject}</span>
                            </>
                          }
                          outlined
                          danger
                          onClick={() => {
                            setIsRejectCategoryRequestModalOpen(true);
                            setCategoryInfo({
                              name: categoryDetails?.Name,
                              id
                            });
                          }}
                        />
                        <Button
                          label={
                            <>
                              <Check className="me-1" />
                              <span>{shared.accept}</span>
                            </>
                          }
                          success
                          onClick={() => {
                            setIsAcceptCategoryRequestModalOpen(true);
                            setCategoryInfo({
                              name: categoryDetails?.Name,
                              id
                            });
                          }}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
              <div className="category-details-container bg-white p-4 border-radius-8">
                <div className="row">
                  <div className="img-container col-md-3 col-12">
                    <img
                      src={categoryDetails.AdminCoverImage}
                      alt="category image"
                      onError={onImageError}
                      className="faint-grey-border w-100 border-radius-8"
                    />
                  </div>
                  <div className="category-details pt-2 col-md-9 col-12">
                    <div className="name mb-3">
                      <p className="mb-1 text-light-grey fsize-13">
                        {requestDetails.categoryName}
                      </p>
                      <p className="mb-0 fsize-20 fweight-500 text-color">
                        {categoryDetails?.Name}
                      </p>
                    </div>
                    <div className="description mb-3">
                      <p className="mb-1 text-light-grey fsize-13">
                        {requestDetails.description}
                      </p>
                      <p className="mb-0 fsize-15 fweight-500 text-color">
                        {categoryDetails?.Description}
                      </p>
                    </div>
                    <div className="requested-by mb-3">
                      <p className="mb-1 text-light-grey fsize-13">
                        {requestDetails.requestedBy}
                      </p>
                      <p className="mb-0 fsize-15 fweight-500 text-color">
                        {categoryDetails?.UserName}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <EmptyState
              subTitle={requestDetails.noRequestFound}
              imgSrc={noCategoryImg}
            />
          )}
        </>
      )}
      {isAcceptCategoryRequestModalOpen && (
        <AcceptCategoryRequest
          open={isAcceptCategoryRequestModalOpen}
          categoryInfo={categoryInfo}
          closeModal={handleCloseModal}
        />
      )}
      {isRejectCategoryRequestModalOpen && (
        <RejectCategoryRequest
          open={isRejectCategoryRequestModalOpen}
          categoryInfo={categoryInfo}
          closeModal={handleCloseModal}
        />
      )}
    </div>
  );
};

export default CategoryRequestDetails;
